import { baseApi } from "../api/baseApi";
import { WorkList, UserWorksParams } from "../types/work.types";

export const workApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWorksByUser: builder.query<WorkList[], UserWorksParams>({
      query: (params) => {
        const queryParams: Record<string, string> = {};

        if (params?.fromDate) {
          queryParams.fromDate = params.fromDate;
        }
        if (params?.toDate) {
          queryParams.toDate = params.toDate;
        }
        if (params?.state !== undefined) {
          queryParams.state = params.state.toString();
        }
        if (params?.userId !== undefined) {
          queryParams.userId = params.userId.toString();
        }

        return {
          url: `/v2/crm/works/by-user`,
          method: "GET",
          params: queryParams,
        };
      },
      providesTags: ["Work"],
    }),
  }),
});

export const { useGetWorksByUserQuery } = workApi;
